<template>
    <div class="row">
        <div class="col position-relative p-3" style="border: solid 1px #8f8f8f;">
            <h2>&nbsp;</h2>
            <h2 class="text-center">Center News</h2>
            <h2>&nbsp;</h2>
        </div>
    </div>
</template>
<script>
export default {
    name: "CenterNewsWidget",
    props: ["user"],
    data() {
        return {
            news: null,
        };
    },
    methods: {
        fetchCenterNews() {
            let endpoint = "";
            axios.post(endpoint).then(r => {
                this.news = r.data.news;
            });
        },
    },
};
</script>
